export enum ApiODINMessageTypeExtraction {
    FAILURE = "FAILURE",
    PROGRESS = "PROGRESS",
    EXTRACTION_SUCCESS = "EXTRACTION_SUCCESS",
}

export enum ApiODINMessageTypeConcurrentUser {
    ACTIVE_USER = "ACTIVE_USER",
    HEARTBEAT = "HEARTBEAT",
}

export enum ApiODINMessageTypeCoAExtraction {
    FAILURE = "FAILURE",
    PROGRESS = "PROGRESS",
    COA_EXTRACTION_SUCCESS = "COA_EXTRACTION_SUCCESS",
}
